import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "item", "hiddenField" ]
  static values = { activeClasses: String }

  connect() {
    if (this.hiddenFieldTarget.value) {
      this.activate(this.hiddenFieldTarget.value);
    }
  }

  select(event) {
    const dogBreedName = event.target.dataset.dogBreedName;
    if (this.hiddenFieldTarget.value !== dogBreedName) {
      this.deactivateIfNeeded(this.hiddenFieldTarget.value);
      this.hiddenFieldTarget.value = dogBreedName;
      this.activate(dogBreedName);
    }
  }

  activate(name) {
    const element = this.itemTargets.find((item) => item.dataset.dogBreedName === name);
    element.classList.add(...this.activeClassesValue.split(" "));
  }

  deactivateIfNeeded(name) {
    const element = this.itemTargets.find((item) => item.dataset.dogBreedName === name);
    if (!element) return;
    element.classList.remove(...this.activeClassesValue.split(" "));
  }
}
